import { render, staticRenderFns } from "./TodoCompany.vue?vue&type=template&id=5133e770&scoped=true&"
import script from "./TodoCompany.vue?vue&type=script&lang=js&"
export * from "./TodoCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133e770",
  null
  
)

export default component.exports